import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import styles from "./styles.module.scss";

export const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        buttonRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsMenuOpen(false);
        document.body.style.overflow = 'auto';
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent body scrolling when menu is open
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'auto';
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className={styles.NavigationWrapper}>
      <nav className={styles.Navigation}>
        <div className={styles.NameSection}>
          <NavLink to="/" onClick={closeMenu}>
            <h1>Zyad Elgohary</h1>
          </NavLink>
        </div>
        
        {/* Desktop Navigation */}
        <div className={styles.DesktopLinks}>
          <NavLink 
            to="/" 
            className={({ isActive }) => 
              isActive ? styles.activeLink : styles.link
            }
          >
            Home
          </NavLink>
          <NavLink 
            to="/companies" 
            className={({ isActive }) => 
              isActive ? styles.activeLink : styles.link
            }
          >
            Companies
          </NavLink>
          <a 
            href="https://x.com/zyadelgoharyx" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.link}
          >
            Twitter
          </a>
          <a 
            href="https://www.linkedin.com/in/zyad-elgohary/" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.link}
          >
            LinkedIn
          </a>
        </div>

        {/* Mobile Hamburger Button */}
        <button 
          ref={buttonRef}
          className={styles.hamburger} 
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <span className={isMenuOpen ? styles.open : ''}></span>
        </button>

        {/* Mobile Menu */}
        <div 
          ref={menuRef}
          className={`${styles.mobileMenu} ${isMenuOpen ? styles.open : ''}`}
        >
          <div className={styles.mobileLinks}>
            <NavLink 
              to="/" 
              className={({ isActive }) => 
                isActive ? styles.activeLink : styles.link
              }
              onClick={closeMenu}
            >
              Home
            </NavLink>
            <NavLink 
              to="/companies" 
              className={({ isActive }) => 
                isActive ? styles.activeLink : styles.link
              }
              onClick={closeMenu}
            >
              Companies
            </NavLink>
            <a 
              href="https://x.com/zyadelgoharyx" 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.link}
              onClick={closeMenu}
            >
              Twitter
            </a>
            <a 
              href="https://www.linkedin.com/in/zyad-elgohary/" 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.link}
              onClick={closeMenu}
            >
              LinkedIn
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
};
